/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Favorite } from 'reactApp/ui/DataListItemCommonComponents/Favorite/Favorite';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { AlbumItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface AlbumProps extends AlbumItemProps {
    checkboxClassname?: string;
    favoriteClassname?: string;
}

export const Album: FC<AlbumProps> = (props) => {
    const { denyDoAction, checkboxClassname, favoriteClassname, isPublic } = props;

    return (
        <>
            <TableColumn>
                <Checkbox
                    className={checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                    isDisabled={denyDoAction}
                    viewType={EViewMode.list}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    author={props.author}
                    isAutoDelete={props?.isAutoDelete}
                    publicExpires={props.publicExpires}
                    isPublic={isPublic}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName
                    name={props.name}
                    ext={props.ext || ''}
                    loading={denyDoAction}
                    id={props.id}
                    isRenameAvailable={props.renameAvailable}
                />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                {!denyDoAction && (
                    <Favorite
                        className={favoriteClassname}
                        isAvailable={!!props.favoritesAvailable}
                        isFavorite={!!props.isInFavorites}
                        onClick={props.onFavorites}
                        viewType={EViewMode.list}
                    />
                )}
                {!denyDoAction && (
                    <Download
                        onClick={props.onDownload}
                        ext={props.isFolder ? 'zip' : props.ext}
                        size={props.size}
                        id={props.id}
                        storage={props.storage}
                        viewType={EViewMode.list}
                    />
                )}
            </TableColumn>
        </>
    );
};
